import React from "react";
import axios from "../../axios";
import { Row, Col, Card, CardTitle } from "reactstrap";
import {
  Avatar,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
} from "@material-ui/core";
import { Input } from "reactstrap";
import { HANDLE_ON_CHANGE } from "../../redux/CommonInitialsate.jsx";
import { toast, Slide } from "react-toastify";
import moment from "moment";
import { Button } from "react-bootstrap";
import { useState, useEffect, useRef } from "react";
import CheckBoxRoundedIcon from "@material-ui/icons/CheckBoxRounded";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import OfflineBoltRoundedIcon from "@material-ui/icons/OfflineBoltRounded";
import Bookmark from "@material-ui/icons/Bookmark";
import KeyboardDoubleArrowUpIcon from "@mui/icons-material/KeyboardDoubleArrowUp";
import { useDispatch, useSelector } from "react-redux";
import Mailandnotification from "../../Mailandnotification.js";
import agile from "../../assets/images/agile.png";
import slacknotify from "../../slacknotify.js";
import AddToPhotosIcon from "@material-ui/icons/AddToPhotos";
import StopCircleIcon from "@mui/icons-material/StopCircle";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import DragHandleIcon from "@material-ui/icons/DragHandle";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import Tooltip from "@mui/material/Tooltip";
import { TextField } from "@mui/material";
import Unassigned from "../../assets/images/avatar.png";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Select, { components } from "react-select";
import Cookies from "universal-cookie";
function HistorySearch(
  {
    // setHistorysearch
  }
) {
  const {
    projectCode,
    allImage,
    releasedata,
    resData,
    projectId2,
    projectName,
    EmpDropDownData,
    slacktoken,
    channelname,
  } = useSelector((state) => state.user);
  const [showClearIcon, setShowClearIcon] = useState(false);
  // const [searchText, setSearchText] = useState("");
  // const inputRef = useRef(null);
  const [columns, setColumns] = useState(1);
  // const [alldata, setAlldata] = useState([]);
  const [fulldata, setfulldata] = useState([]);

  const [expandedCards, setExpandedCards] = useState([]);

  const [sprint, setSprint] = useState(null);
  const [clonedata, setclonedata] = useState([]);
  const [issueTitleedit, setIssueTitleedit] = useState(
    clonedata.IssueTitle || ""
  );
  const [loading, setLoading] = useState(false);
  // const [relese, setRelese] = useState();
  // const [filteredData, setFilteredData] = useState([]);
  const [data, setData] = useState([]);
  const [assignedEmployee, setAssignedEmployee] = useState(null);
  const [assignedEmployeeN, setAssignedEmployeeN] = useState("null null");
  // const [enablesprint, setEnablesprint] = useState(false)
  const [stage, setStage] = useState("Refined");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [input, setInput] = useState("");
  const [Cloned, setcloned] = useState(false);

  const [message, setMessage] = useState("Search History issue");
  const cookies = new Cookies();
  let empid = JSON.parse(localStorage.getItem("Empdetails"));
  let slack = localStorage.getItem("Slack");
  const clientId = localStorage.getItem("clientid");
  const dispatch = useDispatch();
  const fetchdata = (value) => {
    setLoading(true);
    axios
      .get(
        `agilesaas_issue_details?ProjectId=eq.${projectCode}&select=IssueId,ModuleLinked,LinkToIssues,ClientId,CreatedBy,CreatedByDetails,ProjectId,ProjectShortCode,IssueType,IssueTitle,Description,Priority,ActualRelease,OriginalEstimate,AssignedTo,ParentIssue,LinkToEpic,AssignedToDetails&CurrentStage->0->>StageName=in.(Done)&order=CreatedDate.desc&ActualRelease=neq.null&IssueTitle=ilike.*${value}*`
      )
      .then((res) => {
        setData(res.data);
        const id = res.data?.map((e) => e.IssueId).join(",");
        setMessage(
          res.data?.length == 0 ? "No issues found" : "Search history issues"
        );
        axios
          .get(
            `agilesaas_issue_history?ProjectId=eq.${projectCode}&UpdatedField=eq.Kanban Changes&UpdatedFrom=in.(RFD,DEV)&UpdatedTo=in.(DEV,UAT)&select=IssueId,ChangedDate,UpdatedFrom,UpdatedTo&IssueId=in.(${id})`
          )
          .then((res) => {
            setfulldata(res.data);
          })
          .catch((err) => {
            console.error(err);
          });
        setLoading(false);
      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    if (input == "") {
      setData([]);
      setMessage(
        "The historic search results will appear here. Enter keyword to search the tickets"
      );
    }
  }, [input]);
  const releasesOption =
  releasedata?.filter((item) => item.IsReleaseFrozen == "N")?.length == 0
    ? []
    : releasedata
        ?.filter(
          (item) =>
            (item.IsReleaseFrozen == "N" &&
              moment(item.SprintStartDate) < moment() &&
              moment(item.SprintEndDate) > moment()) ||
            moment() < moment(item.SprintStartDate)
        )
        ?.map((e) => {
          return {
            ...e,
            label: e.ReleaseName,
            value: e.ReleaseName,
          };
        });

const filteredRele = releasesOption.filter(
  (release) => moment(release.SprintStartDate).diff(moment(), "days") < 0
);
  const customStyles = {
    control: (base, state) => ({
      ...base,
      background: "#FFF",
      border: state.isFocused
        ? "2px solid rgb(82, 80, 229)"
        : "1px solid rgba(0, 0, 0, 0.10)",
      borderRadius: 8,
      height: "2.875rem",
      // background: "#f3f3ff",
      // match with the menu
      // borderRadius: state.isFocused ? "3px 3px 0 0" : 3,
      // Overwrittes the different states of border
      // borderColor: state.isFocused ? "yellow" : "green",
      // Removes weird border around container
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        // Overwrittes the different states of border
        // borderColor: state.isFocused ? "red" : "blue"
      },
    }),
    menu: (base) => ({
      ...base,
      // override border radius to match the box
      borderRadius: 0,
      // kill the gap
      marginTop: 0,
    }),
    menuList: (base) => ({
      ...base,
      // kill the white space on first and last option
      padding: 0,
    }),
  };
  const releasesOption23 =
   releasedata?.filter((item) => (moment(item.SprintStartDate) < moment() &&
       moment(item.SprintEndDate) > moment()||  moment() < moment(item.SprintStartDate)))
       ?.length == 0
         ? []
         : 
         releasedata
         .filter((item) =>  ( moment(item.SprintStartDate) < moment() &&
                                 moment(item.SprintEndDate) > moment() ||  moment() < moment(item.SprintStartDate)))
   
             ?.map((e) => {
               return {
                 ...e,
                 label: e.ReleaseName,
                 value: e.ReleaseName,
               };
             });
  const EmployeeDropdown = resData
    .filter((x) => x.projectcode == projectId2)
    ?.map((e) => ({
      label: e.firstname + " " + e.lastname,
      value: e.teammemberid,
    }))
    ?.filter(
      (obj, index, self) =>
        index ===
        self.findIndex((o) => o.label === obj.label && o.value === obj.value)
    );
  const handlechange = (value) => {
    setInput(value);
    // fetchdata(value);
  };
  const handleEnterKeyPress = (e) => {
    // console.log(e);
    if (e.key === "Enter" && e.target.value) {
      fetchdata(e.target.value);
    }
  };

  const handleSelectChange = (selectedOption) => {
    setColumns(Number(selectedOption.value)); // Convert the selected value to a number
  };
  function handleAssignedTo(item) {
    setAssignedEmployee(item.value);
    setAssignedEmployeeN(item.label);
  }
  const handleInputChange = (event) => {
    setIssueTitleedit(event.target.value);
  };
  const handleChangepll = (e) => {
    setSprint(e);
  };
  const handleStageChange = (value) => {
    setStage(value);
  };
  const handleChangsde = (selectedOption) => {
    handleChangepll(selectedOption ? selectedOption.value : "");
  };
  const CustomSingleValue = ({ data }) => (
    <div style={{ display: "flex", alignItems: "center" }}>
      <img
        src={agile}
        alt="Image"
        width="30"
        height="30"
        style={{ marginRight: "2px" }}
      />
      <span>{data.label}</span>
    </div>
  );

  const CustomOption = (props) => (
    <components.Option {...props}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src={agile}
          alt="Image"
          width="30"
          height="30"
          style={{ marginRight: "2px" }}
        />
        <span>{props.data.label}</span>
      </div>
    </components.Option>
  );
  function handleclone() {
    // setCloneopen(false);
    setcloned(false);
    setSprint(null);
    setStage("Refined");
    setAssignedEmployee(null);
    setAssignedEmployeeN("null null");
    setIssueTitleedit("");
    setclonedata([]);
  }
  function handleclonesubmit() {
    setIsSubmitting(true);
    const firstname =
      assignedEmployeeN == " " || undefined
        ? " "
        : assignedEmployeeN?.split(" ").length == 3
        ? assignedEmployeeN?.split(" ")[0] +
          " " +
          assignedEmployeeN?.split(" ")[1]
        : assignedEmployeeN?.split(" ")[0];
    console.log(firstname, "fn");
    let emplastname =
      clonedata.IssueType != "Epic" ? assignedEmployeeN?.split(" ").pop() : null;
    let postData = {
      ProjectId: clonedata.ProjectId,
      ProjectShortCode: clonedata.ProjectShortCode,
      IssueType: clonedata.IssueType,
      IssueTitle: issueTitleedit,
      Description: clonedata.Description,
      Priority: clonedata.Priority,
      PlannedRelease: sprint || filteredRele?.[0]?.ReleaseName,
      EstimateUnit: clonedata.IssueType != "Epic" ? "MD" : null,
      EstimateUnitDesc: clonedata.IssueType != "Epic" ? "Man Days" : null,

      CurrentStage: [
        {
          StageCode:
            stage == "Backlog" ? "BLG" : stage == "Refined" ? "RFD" : "BLG",
          StageName:
            stage == "Backlog"
              ? "Backlog"
              : stage == "Refined"
              ? "Refined"
              : "Refined",
          DateMoved: moment().format("YYYY-MM-DD"),
        },
      ],
      LinkToEpic: clonedata?.IssueType != "Epic" ? clonedata?.LinkToEpic : null,
      LinkToIssues:
        clonedata.IssueType != "Epic" ? clonedata.LinkToIssues : null,
      CreatedBy: clonedata.CreatedBy,
      CreatedByDetails: clonedata.CreatedByDetails,
      // arr.RoleName == "Undefined" ? "Kanban Admin" : arr.RoleName,
      CreatedDate: moment().format("YYYY-MM-DD"),
      AssignedTo: clonedata.IssueType != "Epic" ? assignedEmployee : null,
      AssignedToDetails: { FN: firstname, LN: emplastname },
      AssignedDate: moment().format("YYYY-MM-DD"),
      Attachment: clonedata.IssueType != "Epic" ? clonedata?.Attachment : null,
      IsActive: "Y",
      ExceptiontoSkipSPEstimation: "N",
      ProjectDetails: [{ ProjName: projectName }],
      AssignedToUAT: null,
      AssignedToUATDetails: {
        FN: null,
        LN: null,
      },
      ClientId: clonedata.ClientId,
      ModuleLinked: clonedata.ModuleLinked,
      AttachmentReference: null,
    };

    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + cookies.get("token"),
      Prefer: "return=representation",
    };

    axios
      .post("agilesaas_issue_details", postData, { headers })
      .then((ress) => {
        const newData = [
          {
            IssueId: ress.data?.[0]?.IssueId,
            IssueTitle: ress.data?.[0]?.IssueTitle,
          },
        ];

        axios
          .get(`agilesaas_releases?ReleaseName=eq.${sprint}`)
          .then((response) => {
            const existingReleaseIssues = response.data[0]?.ReleaseIssues || [];
            const updatedReleaseIssues = [...existingReleaseIssues, ...newData];

            axios
              .patch(`agilesaas_releases?ReleaseName=eq.${sprint}`, {
                ReleaseIssues: updatedReleaseIssues,
              })
              .then((patchResponse) => {})
              .catch((patchError) => {
                console.error("Error updating ReleaseIssues:", patchError);
              });
            const historyDataArray = {
              IssueId: ress?.data?.[0]?.IssueId,
              ChangedBy: empid?.[0]?.ClientUserId,
              ChangedByDetails: {
                FN: empid?.[0]?.UserFirstname,
                LN: empid?.[0]?.UserLastname,
              },
              ChangedDate: moment().format("YYYY-MM-DDTHH:mm:ss"),
              UpdatedField: "Issue created",
              UpdatedFrom: "",
              UpdatedTo:
                clonedata.IssueType != "Epic" && assignedEmployee
                  ? "Issue created by " +
                    empid?.[0]?.UserFirstname +
                    " " +
                    empid?.[0]?.UserLastname +
                    " and allocated to " +
                    firstname +
                    " " +
                    emplastname
                  : "Issue created by " +
                    empid?.[0]?.UserFirstname +
                    " " +
                    empid?.[0]?.UserLastname,
              UpdateSequence: null,
              IsActive: "Y",
              Status: null,
              ClientId: clientId,
              ProjectId: projectCode,
            };

            axios
              .post("agilesaas_issue_history", historyDataArray)
              .then((response) => {
                // toast.success("Stage updated successfully");
                // alert("Stage updated successfully");
                console.log("response", response);
              })
              .catch((error) => {
                console.error("Error updating stage:");
              });
          })
          .catch((error) => {
            console.error("Error fetching existing data:", error); // Handle GET request error
          });
        toast.success(
          `Success! Issue ${clonedata.IssueId} has been cloned and added to the ${stage} `,
          {
            transition: Slide,
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 3000,
            draggable: true,
          }
        );
        Mailandnotification(
          clonedata,
          EmpDropDownData?.filter(
            (x) => x.teammemberid == assignedEmployee
          )?.[0]?.email,
          [empid?.[0]?.OfficialEmail],
          true,
          true,
          projectName,
          `Issue created ,
        ${issueTitleedit} has been created by ${
            empid?.[0]?.UserFirstname + " " + empid?.[0]?.UserLastname
          } in project ${projectName}`
        );
        if (slack && slack == "Y") {
          slacknotify(
            channelname,
            `${issueTitleedit} is created and assigned to ${
              EmpDropDownData?.filter(
                (x) => x.teammemberid == assignedEmployee
              )?.[0]?.firstname +
              " " +
              EmpDropDownData?.filter(
                (x) => x.teammemberid == assignedEmployee
              )?.[0]?.lastname
            } by ${
              empid?.[0]?.UserFirstname + " " + empid?.[0]?.UserLastname
            } in project ${projectName}`,
            slacktoken
          );
        }
        setIsSubmitting(false);
        dispatch(HANDLE_ON_CHANGE({ name: "Refresh", value: true }));
        handleclone();
      })
      .catch((e) => {
        console.log(e, "error");
        setIsSubmitting(false);
        handleclone();
      });
  }
  const handleShowMore = (issueId) => {
    setExpandedCards((prevExpandedCards) =>
      prevExpandedCards?.includes(issueId)
        ? prevExpandedCards?.filter((id) => id !== issueId)
        : [...prevExpandedCards, issueId]
    );
  };

  const mergedData = data?.map((issue) => {
    const startdate = fulldata?.filter(
      (change) =>
        change.IssueId === issue.IssueId &&
        change.UpdatedFrom == "RFD" &&
        change.UpdatedTo == "DEV"
    )?.[0]?.ChangedDate;
    const enddate = fulldata?.filter(
      (change) =>
        change.IssueId === issue.IssueId &&
        change.UpdatedFrom == "DEV" &&
        change.UpdatedTo == "UAT"
    )?.[0]?.ChangedDate;
    return {
      ...issue,
      startdate: startdate,
      enddate: enddate,
    };
  });

  const renderCards = () => {
    return loading ? (
      <div
        className=" d-flex align-items-center"
        style={{ justifyContent: "center", height: 460 }}
      >
        <span
          className="spinner-border"
          role="status"
          aria-hidden="true"
          style={{ color: "rgb(82, 80, 229)" }}
        ></span>
      </div>
    ) : mergedData?.length > 0 ? (
      <Row className="mt-3">
        {mergedData?.map((e) => (
          <Col key={e.IssueId} md={12 / columns}>
            <Card
              className=" rounded pr-2 pl-3 pt-3 pb-2 shadow-sm border mt-3"
              style={{
                width: "100%", // Full width of the parent container
                maxWidth: "700px",
                margin: "auto",
                // height: expandedCards.includes(e.IssueId) ? "auto" : "220px",
                // overflow: "hidden",
              }}
            >
              <Row>
                <Col className="">
                  <div className="d-flex ">
                    <Tooltip
                      title={e.IssueType}
                      arrow
                      placement="top"
                      offset={[0, -3]}
                      style={{ cursor: "pointer" }}
                    >
                      <span className="cardIcon2 ">
                        {e.IssueType === "Story" ? (
                          <Bookmark
                            className="story fonticons"
                            style={{ fontSize: "13px" }}
                          />
                        ) : e.IssueType === "Task" ? (
                          <CheckBoxRoundedIcon
                            className="task fonticons"
                            style={{ fontSize: "13px" }}
                          />
                        ) : e.IssueType === "Bug" ? (
                          <StopCircleIcon
                            style={{ fontSize: "13px" }}
                            className="bug fonticons"
                          />
                        ) : e.IssueType === "Epic" ? (
                          <OfflineBoltRoundedIcon
                            style={{ fontSize: "13px" }}
                            className="epic fonticons"
                          />
                        ) : e.IssueType === "SubTask" ? (
                          <AddToPhotosIcon
                            // className="kanbanicon task"
                            className="task fonticons"
                            style={{ fontSize: "13px" }}
                          />
                        ) : (
                          ""
                        )}
                      </span>
                    </Tooltip>
                    <span
                      className="mt-1 rounded"
                      style={{
                        fontSize: "12px",
                        marginLeft: "2px",
                        // color: "#198ae3",

                        whiteSpace: "pre-wrap",
                      }}
                    >
                      {e.IssueId} {"-"}
                    </span>

                    <Tooltip
                      title={e.IssueTitle}
                      arrow
                      placement="top"
                      offset={[0, -1]}
                      style={{ cursor: "pointer" }}
                    >
                      <lable
                        style={{
                          fontSize: "1rem",
                          marginLeft: "10px",
                          fontWeight: "bold",
                          overflow: "hidden",
                          // fontWeight: "550",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",

                          maxWidth: columns === 1 ? "400px" : "240px",
                          // : "180px", // You can adjust the max width as needed
                          display: "inline-block",
                        }}
                      >
                        {e.IssueTitle}
                      </lable>
                    </Tooltip>
                    <Tooltip
                      title={e.Priority}
                      arrow
                      placement="top"
                      offset={[0, -3]}
                    >
                      <lable className="ml-1">
                        {e.Priority === "Highest" ? (
                          <KeyboardDoubleArrowUpIcon
                            className="filter-icons-1"
                            fontSize="small"
                          />
                        ) : e.Priority === "High" ? (
                          <KeyboardArrowUpIcon
                            className="filter-icons-1"
                            fontSize="small"
                          />
                        ) : e.Priority === "Medium" ? (
                          <DragHandleIcon
                            className="filter-icons"
                            fontSize="small"
                          />
                        ) : e.Priority === "Low" ? (
                          <KeyboardArrowDownIcon
                            className="filter-icons-2"
                            fontSize="small"
                          />
                        ) : e.Priority === "Lowest" ? (
                          <KeyboardDoubleArrowDownIcon
                            className="filter-icons-2"
                            fontSize="small"
                          />
                        ) : (
                          ""
                        )}
                      </lable>
                    </Tooltip>
                  </div>
                </Col>

                <Col md={2} className=" d-flex justify-content-center  ">
                  {/* <label style={{ fontSize: "12px" }} className="mt-1">
                    {e.AssignedToDetails.FN}
                  </label> */}
                  <Tooltip
                    title={e.AssignedToDetails.FN}
                    arrow
                    placement="top"
                    offset={[0, -3]}
                    style={{ cursor: "pointer" }}
                  >
                    <Avatar
                      sx={{ width: 24, height: 24, marginLeft: "5px" }}
                      src={
                        allImage?.length > 0
                          ? allImage?.filter(
                              (x) => x.teammemberid == e.AssignedTo
                            )?.[0]?.image
                          : Unassigned
                      }
                    ></Avatar>
                  </Tooltip>
                </Col>
              </Row>

              {/* <Row className="mt-1">

              </Row> */}
              <Row>
                <Col>
                  <label
                    className="mt-2"
                    style={{
                      fontSize: "12px",
                      color: "grey",
                      height: expandedCards.includes(e.IssueId)
                        ? "auto"
                        : "100px",
                      overflow: "hidden",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: e.Description?.replace(/<img .*?>/g, ""),
                    }}
                  >
                    {/* {e.Description} */}
                    {/* {console.log(
                        e.Description.replace(/<img .*?>/g, "").length
                      )} */}
                    {/* {Description?.match(/<img .*?>/g)?.length} */}
                  </label>
                  {e.Description?.replace(/<img .*?>/g, "").length > 150 && (
                    <span
                      style={{
                        color: "blue",
                        cursor: "pointer",
                        fontSize: "12px",
                      }}
                      onClick={() => handleShowMore(e.IssueId)}
                    >
                      {expandedCards.includes(e.IssueId)
                        ? "Show Less"
                        : "Show More"}
                    </span>
                  )}
                </Col>
              </Row>
              <Row>
                <Col md={columns === 1 ? 3 : columns === 2 ? 6 : 6}>
                  <label style={{ fontSize: "14px" }}>Sprint: </label>
                  <span
                    className="SprintlabelStyle rounded"
                    style={{ backgroundColor: "lightcyan" }}
                  >
                    {" "}
                    {e.ActualRelease}
                  </span>
                </Col>
                <Col
                  md={columns === 1 ? 3 : columns === 2 ? 6 : 6}
                  className="p-0"
                >
                  {/* <label style={{ fontSize: "1rem" }}>OriginalEstimate</label> */}
                  {/* <span class="mdi mdi-timer-sand"></span> */}
                  <label style={{ fontSize: "14px" }}>
                    OriginalEstimate:{""}
                  </label>
                  <span className="SprintlabelStyle ">
                    {"  "}
                    {e.OriginalEstimate}
                  </span>
                </Col>
                <Col
                  md={columns === 1 ? 3 : columns === 2 ? 6 : 6}
                  className=" p-0"
                >
                  <label
                    style={{
                      fontSize: "14px",
                      marginLeft: columns === 2 && "20px",
                    }}
                  >
                    {" "}
                    Startdate:
                  </label>
                  {/* <label style={{ fontSize: "1rem" }}>Startdate</label> */}
                  <span className="SprintlabelStyle">
                    {" "}
                    {moment(e.startdate).format("DD-MMM-YYYY")}
                  </span>
                </Col>
                <Col
                  md={columns === 1 ? 3 : columns === 2 ? 6 : 6}
                  className=" p-0"
                >
                  <label style={{ fontSize: "14px" }}>Enddate:</label>
                  {/* <label style={{ fontSize: "1rem" }}>Enddate</label> */}
                  <span className="SprintlabelStyle">
                    {" "}
                    {moment(e.enddate).format("DD-MMM-YYYY")}
                  </span>
                </Col>
                <Col className="p-0 d-flex justify-content-end mr-5">
                  <Tooltip arrow placement="top" title="Clone">
                    <IconButton
                      className="hidden-button1"
                      onClick={(event) => {
                        // handle the clone action
                        event.stopPropagation();
                        setcloned(true);
                        setclonedata(e);
                        setIssueTitleedit(e.IssueTitle);
                      }}
                    >
                      <ContentCopyIcon
                        style={{ fontSize: "16px", color: "#4bade8" }}
                      />
                    </IconButton>
                  </Tooltip>
                </Col>
              </Row>
            </Card>
          </Col>
        ))}
      </Row>
    ) : (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "200px" }}
      >
        <label style={{ fontSize: "18px" }}>
          <span class="mdi mdi-alert-circle-outline"></span>
          {"  "}
          {/* {mergedData?.length > 0 ? "No" : "yes"} */}
          {message}
        </label>
      </div>
    );
  };
  // console.log(data);
  return (
    <div>
      <div>
        <div className="d-flex justify-content-center mt-2">
          <TextField
            id="filled-search"
            label="Enter any keyword to search the historic tickets"
            type="text"
            variant="outlined"
            size="small"
            value={input}
            onChange={(e) => handlechange(e.target.value)}
            onKeyPress={handleEnterKeyPress}
          />
          {input && (
            <Button
              size="sm"
              className="ml-3 bg-info border-0"
              onClick={() => fetchdata(input)}
            >
              Search
            </Button>
          )}
        </div>
      </div>
      <div className="mt-2">{renderCards()}</div>
      <Dialog
        open={Cloned}
        onClose={handleclone}
        className="mainbox"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Row
            className=""
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <Col lg={10} md={10}>
              <label
                className="text-secondary fontdesign"
                style={{ fontWeight: "bold" }}
              >
                Clone the ticket with Id - ({clonedata.IssueId})
              </label>
            </Col>
            <div className="d-flex justify-content-end">
              <IconButton onClick={handleclone}>
                <CloseIcon />
              </IconButton>
            </div>
          </Row>
        </DialogTitle>
        <DialogContent>
          <div style={{ textAlign: "center", marginBottom: "20px" }}>
            <label
              style={{
                fontWeight: "bold",
                fontSize: "14px",
                display: "block",
                marginBottom: "10px",
              }}
            >
              In which stage, the card should be cloned to
            </label>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",
                marginBottom: "20px",
              }}
            >
              <button
                type="button"
                className={`btn btn-custom ${
                  stage === "Refined" ? "selected" : "not-selected"
                }`}
                value="Refined"
                onClick={() => handleStageChange("Refined")}
              >
                Refined
              </button>
              <button
                type="button"
                className={`btn btn-custom ${
                  stage === "Backlog" ? "selected" : "not-selected"
                }`}
                value="Backlog"
                onClick={() => handleStageChange("Backlog")}
              >
                Backlog
              </button>
            </div>
          </div>
          <Box marginBottom="20px">
            <label
              style={{
                fontWeight: "bold",
                fontSize: "14px",
                display: "block",
                marginBottom: "10px",
              }}
            >
              Title
            </label>
            <Input
              onChange={handleInputChange}
              value={issueTitleedit}
              className="SprintFormFields"
              placeholder="Enter Title"
              fullWidth
            />
          </Box>
          <Box marginBottom="20px">
            <label
              style={{
                fontWeight: "bold",
                fontSize: "14px",
                display: "block",
                marginBottom: "10px",
              }}
            >
              Select Sprint
              {releasesOption23.length === 0 && (
                <div className="text-muted" style={{ marginTop: "10px" }}>
                  No active sprints available
                </div>
              )}
            </label>
            <Select
              styles={customStyles}
              options={releasesOption23}
              value={
                releasesOption23 &&
                releasesOption23.find((option) => option.value === sprint)
              }
              onChange={handleChangsde}
              placeholder={<span>Select Sprint</span>}
              components={{
                SingleValue: CustomSingleValue,
                Option: CustomOption,
              }}
              isDisabled={releasesOption23.length === 0}
            />
          </Box>

          <Box marginBottom="70px" marginTop="20px">
            <label
              style={{
                fontWeight: "bold",
                fontSize: "14px",
                display: "block",
                marginBottom: "10px",
              }}
            >
              Assigned To
            </label>
            <Select
              name="AssignedTo"
              placeholder="Select Employee"
              options={EmployeeDropdown}
              styles={customStyles}
              onChange={handleAssignedTo}
              value={EmployeeDropdown.filter(
                (option) => option.label === assignedEmployeeN
              )}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button
              onClick={handleclone}
              style={{
                fontSize: 14,
                padding: 9,
                width: 100,
                height: 40,
                borderRadius: 8,
                marginRight: 14,
                border: "2px solid #5250E5",
                backgroundColor: "#fff",
                color: "#5250E5",
                textAlign: "center",
                textTransform: "none",
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleclonesubmit}
              disabled={isSubmitting}
              style={{
                fontSize: 14,
                padding: 9,
                width: 100,
                height: 40,
                borderRadius: 8,
                backgroundColor: "#5250E5",
                color: "#fff",
                border: "0px solid #5A88F1",
                textAlign: "center",
                textTransform: "none",
              }}
            >
              Submit
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default HistorySearch;
